import styled from "@emotion/styled";
import ProductList from "../components/ProductList/ProductList";

const HomeStyle = styled.div``;

function Home() {
  return (
    <HomeStyle>
      <ProductList />
    </HomeStyle>
  );
}

export default Home;
